import * as React from "react";
import SelectPhoneModalForm from "../../Forms/buypermits/SelectPhoneModalForm";
import BaseModal, { BaseModalContent } from "../BaseModal";

const SelectPhoneModal=(props)=>{ 
   const {isOpenSelectPhoneModal,CloseSelectPhoneModal,handleOpenAddPhoneModal} = props;

//    useEffect(() => {
//     const ActiveData = emailData && emailData.filter((items) => {
//       return items.inactive === false
//     })
//     setMyEmailData(ActiveData)
//     dispatch(getCheckoutSelectPhoneStates({accountId:1337}));
//   }, [emailData])

   
    return(
        <>
            <BaseModal
                title="Select Phone"
                align="center"
                open={isOpenSelectPhoneModal}
                onClose={CloseSelectPhoneModal}
                with={500}                
            >
                <BaseModalContent>
                   <SelectPhoneModalForm 
                      CloseSelectPhoneModal={CloseSelectPhoneModal}
                      handleOpenAddPhoneModal={handleOpenAddPhoneModal}
                   />
                </BaseModalContent>
            </BaseModal>
        </>
    )
}
export default SelectPhoneModal;